"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornVerticalNavigationItem = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AcornVerticalNavigationItem = function (props) {
    return (react_1.default.createElement("li", { className: 'c-nav__item +secondary-level' + (props.active ? ' +active' : '') },
        react_1.default.createElement(react_router_dom_1.Link, { to: props.path }, props.name)));
};
exports.AcornVerticalNavigationItem = AcornVerticalNavigationItem;
//# sourceMappingURL=AcornVerticalNavigationItem.js.map